import { inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, shareReplay, startWith } from 'rxjs/operators';

export function injectCurrentUrl() {
  const router = inject(Router);
  return router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => router.url),
    startWith(router.url),
    shareReplay({ bufferSize: 1, refCount: true }),
  );
}
